export { default } from "./CurtailmentObjectHistorySliderContainer";
